<template>
  <div class="lwnp-wrapper">
    <div class="lwnp-box nf-bg">
      <!-- Header bar -->
      <div class="nf-header">
        <button class="nf-back" type="button" @click="nfBack" aria-label="ย้อนกลับ" v-if="nfStep !== 'done'">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"></path></svg>
        </button>
        <span v-else></span>
        <span class="nf-header-title">{{ nfHeaderTitle }}</span>
        <span></span>
      </div>

      <!-- No phone in URL -->
      <div class="nf-pane" v-if="!notFoundPhone">
        <div class="nf-warn" aria-hidden="true">!</div>
        <h2 class="nf-title nf-center">ไม่พบเบอร์โทรศัพท์</h2>
        <p class="nf-body nf-center">กรุณาเข้าลิงก์นี้ผ่านช่องทางที่ได้รับ</p>
      </div>

      <!-- Step: intro -->
      <div class="nf-pane" v-else-if="nfStep === 'intro'">
        <h2 class="nf-title">เชื่อมประวัติด้วยเบอร์ใหม่</h2>
        <p class="nf-body">สำหรับคนไข้ที่เคยใช้บริการคลินิก Makalin แต่เชื่อมประวัติ Makalin Connect ไม่สำเร็จ เนื่องจากเบอร์โทรศัพท์ปัจจุบันไม่ตรงกับเบอร์ที่บันทึกไว้ในระบบคนไข้</p>
        <div class="nf-hero-card">
          <small>ขออัปเดตเบอร์โทรศัพท์</small>
          <b>ใช้เวลากรอกประมาณ 2 นาที</b>
          <span>กรอกครั้งเดียว ระบบจะเชื่อมประวัติให้อัตโนมัติเมื่อเจ้าหน้าที่อัปเดตข้อมูลแล้ว</span>
        </div>
        <ol class="nf-steps-list">
          <li><span class="nf-step-n">1</span><div>กรอกข้อมูลคนไข้</div></li>
          <li><span class="nf-step-n">2</span><div>เจ้าหน้าที่ตรวจสอบและอัปเดตเบอร์ในระบบคนไข้</div></li>
          <li><span class="nf-step-n">3</span><div>รอผลการเชื่อมประวัติอัตโนมัติทาง LINE</div></li>
        </ol>
        <div class="nf-prep"><b>ข้อมูลที่ต้องใช้ &nbsp;</b>ชื่อและนามสกุลที่เคยลงทะเบียนไว้กับคลินิก (รวมชื่อหรือนามสกุลเดิม หากเคยเปลี่ยน), วันเดือนปีเกิด และเบอร์เดิม (หากจำได้)</div>
        <button class="nf-btn" type="button" @click="goForm">เริ่มกรอกข้อมูล</button>
        <p class="nf-body nf-center" style="font-size:.82rem">ยังไม่เคยใช้บริการที่คลินิก? <button class="nf-link" type="button" @click="goOnlineNewPatient">ลงทะเบียนคนไข้ใหม่</button></p>
      </div>

      <!-- Step: form -->
      <div class="nf-pane nf-pane-form" v-else-if="nfStep === 'form'">
        <div class="nf-sec-title">ข้อมูลคนไข้</div>
        <div class="nf-field" :class="{ 'nf-field-invalid': formErrors.fname }">
          <label class="nf-label" for="nf-fname">ชื่อปัจจุบัน<span class="nf-req">*</span></label>
          <input id="nf-fname" class="nf-input" type="text" v-model="formFname" autocomplete="given-name" placeholder="ชื่อจริง ไม่ต้องใส่คำนำหน้า">
          <span class="nf-err" v-if="formErrors.fname">{{ formErrors.fname }}</span>
        </div>
        <label class="nf-check"><input type="checkbox" v-model="formChangedFn"> เคยเปลี่ยนชื่อหลังจากเริ่มใช้บริการ</label>
        <div class="nf-field nf-sub-field" v-if="formChangedFn" :class="{ 'nf-field-invalid': formErrors.oldfname }">
          <label class="nf-label" for="nf-oldfname">ชื่อเดิม<span class="nf-req">*</span></label>
          <input id="nf-oldfname" class="nf-input" type="text" v-model="formOldFname" placeholder="ชื่อที่เคยลงทะเบียนไว้กับคลินิก">
          <span class="nf-err" v-if="formErrors.oldfname">{{ formErrors.oldfname }}</span>
        </div>
        <div class="nf-field" :class="{ 'nf-field-invalid': formErrors.lname }">
          <label class="nf-label" for="nf-lname">นามสกุลปัจจุบัน<span class="nf-req">*</span></label>
          <input id="nf-lname" class="nf-input" type="text" v-model="formLname" autocomplete="family-name">
          <span class="nf-err" v-if="formErrors.lname">{{ formErrors.lname }}</span>
        </div>
        <label class="nf-check"><input type="checkbox" v-model="formChangedLn"> เคยเปลี่ยนนามสกุลหลังจากเริ่มใช้บริการ</label>
        <div class="nf-field nf-sub-field" v-if="formChangedLn" :class="{ 'nf-field-invalid': formErrors.oldlname }">
          <label class="nf-label" for="nf-oldlname">นามสกุลเดิม<span class="nf-req">*</span></label>
          <input id="nf-oldlname" class="nf-input" type="text" v-model="formOldLname" placeholder="นามสกุลที่เคยลงทะเบียนไว้กับคลินิก">
          <span class="nf-err" v-if="formErrors.oldlname">{{ formErrors.oldlname }}</span>
        </div>
        <div class="nf-field" :class="{ 'nf-field-invalid': formErrors.dob }">
          <span class="nf-label">วันเดือนปีเกิด<span class="nf-req">*</span></span>
          <div class="nf-row3">
            <select class="nf-select" v-model="formDobDay" aria-label="วัน">
              <option value="">วัน</option>
              <option v-for="d in dobDays" :key="d" :value="d">{{ d }}</option>
            </select>
            <select class="nf-select" v-model="formDobMonth" aria-label="เดือน">
              <option value="">เดือน</option>
              <option v-for="m in dobMonths" :key="m.value" :value="m.value">{{ m.label }}</option>
            </select>
            <select class="nf-select" v-model="formDobYear" aria-label="ปี พ.ศ.">
              <option value="">ปี พ.ศ.</option>
              <option v-for="y in dobYears" :key="y" :value="y">{{ y }}</option>
            </select>
          </div>
          <span class="nf-err" v-if="formErrors.dob">{{ formErrors.dob }}</span>
        </div>
        <div class="nf-sec-title">เบอร์โทรศัพท์</div>
        <div class="nf-field" :class="{ 'nf-field-invalid': formErrors.oldphone }">
          <label class="nf-label" for="nf-oldphone">เบอร์เดิมที่เคยให้ไว้กับคลินิก<span class="nf-opt">ไม่บังคับ</span></label>
          <input id="nf-oldphone" class="nf-input" type="tel" v-model="formOldPhone" :disabled="formForgotOld" placeholder="0XX-XXX-XXXX" maxlength="10" inputmode="numeric">
          <span class="nf-err" v-if="formErrors.oldphone">{{ formErrors.oldphone }}</span>
        </div>
        <label class="nf-check"><input type="checkbox" v-model="formForgotOld"> จำเบอร์เดิมไม่ได้</label>
        <div class="nf-field">
          <span class="nf-label">เบอร์ใหม่ที่ต้องการอัปเดต</span>
          <div class="nf-phone-locked">
            <b>{{ formatPhone(notFoundPhone) }}</b>
            <span class="nf-verified">✓ ยืนยัน OTP แล้ว</span>
          </div>
          <span class="nf-help">เบอร์นี้ยืนยันด้วยรหัส OTP แล้วตั้งแต่ขั้นตอนเชื่อมประวัติ</span>
        </div>
        <div class="nf-sec-title">ความยินยอม</div>
        <div class="nf-field" :class="{ 'nf-field-invalid': formErrors.consent }">
          <label class="nf-check"><input type="checkbox" v-model="formConsent"> ข้าพเจ้ายินยอมให้คลินิก Makalin ใช้ข้อมูลข้างต้นเพื่อยืนยันตัวตน ปรับปรุงเบอร์โทรศัพท์ในระบบคนไข้ และเชื่อมประวัติ Makalin Connect ตามนโยบายความเป็นส่วนตัวของคลินิก</label>
          <span class="nf-err" v-if="formErrors.consent">{{ formErrors.consent }}</span>
        </div>
        <span class="nf-form-err" v-if="formErrors.general">{{ formErrors.general }}</span>
        <button class="nf-btn" type="button" @click="submitPhoneUpdateForm" :disabled="formSubmitting">ส่งคำขอ</button>
      </div>

      <!-- Step: done -->
      <div class="nf-pane" v-else-if="nfStep === 'done'">
        <div class="nf-done-mark" aria-hidden="true">✓</div>
        <h2 class="nf-title nf-center">ได้รับคำขอของคุณแล้ว</h2>
        <div class="nf-phone nf-center" v-if="formResult && formResult.ref">{{ formResult.ref }}</div>
        <p class="nf-body">เจ้าหน้าที่จะตรวจสอบและอัปเดตเบอร์โทรศัพท์ในระบบคนไข้ภายใน 1 วันทำการ เมื่ออัปเดตแล้ว ระบบจะเชื่อมประวัติ Makalin Connect ให้อัตโนมัติ และแจ้งผลทาง LINE นี้ คุณไม่ต้องทำรายการซ้ำ</p>
        <dl class="nf-kv" v-if="formResult && formResult.rows">
          <template v-for="row in formResult.rows" :key="row[0]">
            <dt>{{ row[0] }}</dt><dd>{{ row[1] }}</dd>
          </template>
        </dl>
        <button class="nf-btn" type="button" @click="closeOrHome">ปิดหน้านี้</button>
      </div>

      <!-- Step: pending -->
      <div class="nf-pane" v-else-if="nfStep === 'pending'">
        <h2 class="nf-title">คำขออยู่ระหว่างตรวจสอบ</h2>
        <span class="nf-pill">รอตรวจสอบ</span>
        <dl class="nf-kv" v-if="pendingInfo">
          <dt>เลขที่คำขอ</dt><dd>{{ pendingInfo.request_id }}</dd>
          <dt>ส่งเมื่อ</dt><dd>{{ formatPendingDate(pendingInfo.created_at) }}</dd>
          <dt>เบอร์ใหม่</dt><dd>{{ formatPhone(notFoundPhone) }}</dd>
        </dl>
        <p class="nf-body">ไม่ต้องส่งคำขอซ้ำ ระบบจะเชื่อมประวัติให้อัตโนมัติและแจ้งผลทาง LINE นี้ หากต้องการแก้ไขข้อมูล กรุณาพิมพ์แจ้งในแชท</p>
        <button class="nf-btn" type="button" @click="closeOrHome">ปิดหน้านี้</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import liff from '@line/liff'
import userApi from '@/api/user'

export default {
  name: 'LoginWithNewPhone',
  setup() {
    const router = useRouter()
    const route = useRoute()

    const notFoundPhone = computed(() => (route.query.phone || '').toString().trim())

    const nfStep = ref('intro')

    const formFname = ref('')
    const formOldFname = ref('')
    const formChangedFn = ref(false)
    const formLname = ref('')
    const formOldLname = ref('')
    const formChangedLn = ref(false)
    const formDobDay = ref('')
    const formDobMonth = ref('')
    const formDobYear = ref('')
    const formOldPhone = ref('')
    const formForgotOld = ref(false)
    const formConsent = ref(false)
    const formErrors = ref({})
    const formSubmitting = ref(false)
    const formResult = ref(null)
    const pendingInfo = ref(null)

    const dobDays = Array.from({ length: 31 }, (_, i) => i + 1)
    const dobMonths = ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'].map((label, i) => ({ value: i + 1, label }))
    const dobYears = Array.from({ length: 101 }, (_, i) => 2569 - i)

    const nfHeaderTitle = computed(() => {
      const map = { intro: 'เชื่อมประวัติด้วยเบอร์ใหม่', form: 'กรอกข้อมูล', done: 'ส่งคำขอเรียบร้อย', pending: 'สถานะคำขอ' }
      return map[nfStep.value] || 'เชื่อมประวัติด้วยเบอร์ใหม่'
    })

    const formatPhone = (p) => {
      const d = String(p).replace(/\D/g, '')
      if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`
      return p
    }

    const formatPendingDate = (dateStr) => {
      if (!dateStr) return ''
      try { return new Date(dateStr).toLocaleString('th-TH', { dateStyle: 'medium', timeStyle: 'short' }) }
      catch { return dateStr }
    }

    const nfBack = () => {
      if (nfStep.value === 'form') {
        nfStep.value = 'intro'
      } else {
        router.back()
      }
    }

    const goForm = () => {
      nfStep.value = 'form'
    }

    const goOnlineNewPatient = () => {
      router.push('/user/register')
    }

    const closeOrHome = () => {
      router.replace('/my-profile')
    }

    const submitPhoneUpdateForm = async () => {
      formErrors.value = {}
      const e = {}
      if (!formFname.value.trim()) e.fname = 'กรุณากรอกชื่อปัจจุบัน'
      if (formChangedFn.value && !formOldFname.value.trim()) e.oldfname = 'กรุณากรอกชื่อเดิม'
      if (!formLname.value.trim()) e.lname = 'กรุณากรอกนามสกุลปัจจุบัน'
      if (formChangedLn.value && !formOldLname.value.trim()) e.oldlname = 'กรุณากรอกนามสกุลเดิม'
      if (!formDobDay.value || !formDobMonth.value || !formDobYear.value) e.dob = 'กรุณาเลือกวันเดือนปีเกิดให้ครบ'
      if (!formConsent.value) e.consent = 'กรุณายืนยันความยินยอมก่อนส่งคำขอ'
      if (Object.keys(e).length) { formErrors.value = e; return }
      formSubmitting.value = true
      try {
        const profile = await liff.getProfile().catch(() => ({ userId: '', displayName: '' }))
        const res = await userApi.submitPhoneUpdateRequest({
          line_user_id: profile.userId,
          line_display_name: profile.displayName,
          first_name: formFname.value.trim(),
          last_name: formLname.value.trim(),
          previous_first_name: formChangedFn.value ? formOldFname.value.trim() : '',
          previous_last_name: formChangedLn.value ? formOldLname.value.trim() : '',
          dob_day: String(formDobDay.value),
          dob_month: String(formDobMonth.value),
          dob_year: String(formDobYear.value),
          last_branch_id: '',
          old_phone: formForgotOld.value ? '' : String(formOldPhone.value).replace(/\D/g, ''),
          new_phone: String(notFoundPhone.value).replace(/\D/g, ''),
          otp_verified_at: new Date().toISOString(),
          consent: true,
        })
        const monthLabel = dobMonths[Number(formDobMonth.value) - 1]?.label || formDobMonth.value
        const dob = `${formDobDay.value} ${monthLabel} ${formDobYear.value}`
        const rows = [['ชื่อ-นามสกุล', `${formFname.value.trim()} ${formLname.value.trim()}`]]
        if (formChangedFn.value || formChangedLn.value) {
          const oldName = [formOldFname.value.trim(), formOldLname.value.trim()].filter(Boolean).join(' ')
          if (oldName) rows.push(['ชื่อ/นามสกุลเดิม', oldName])
        }
        rows.push(['วันเกิด', dob])
        rows.push(['เบอร์ใหม่', formatPhone(notFoundPhone.value)])
        formResult.value = { ref: res?.request_id || res?.id || '', rows }
        nfStep.value = 'done'
      } catch (err) {
        formErrors.value = { general: err?.detail || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง' }
      } finally {
        formSubmitting.value = false
      }
    }

    onMounted(async () => {
      if (!notFoundPhone.value) return
      try {
        const res = await userApi.checkPhoneUpdateRequest(String(notFoundPhone.value).replace(/\D/g, ''))
        if (res?.has_pending) {
          pendingInfo.value = res
          nfStep.value = 'pending'
        }
      } catch {
        // silently fall through to intro
      }
    })

    return {
      notFoundPhone,
      nfStep,
      nfHeaderTitle,
      formatPhone,
      formatPendingDate,
      nfBack,
      goForm,
      goOnlineNewPatient,
      closeOrHome,
      submitPhoneUpdateForm,
      formFname,
      formOldFname,
      formChangedFn,
      formLname,
      formOldLname,
      formChangedLn,
      formDobDay,
      formDobMonth,
      formDobYear,
      formOldPhone,
      formForgotOld,
      formConsent,
      formErrors,
      formSubmitting,
      formResult,
      pendingInfo,
      dobDays,
      dobMonths,
      dobYears,
    }
  }
}
</script>

<style lang="scss" scoped>
.lwnp-wrapper {
  min-height: 100vh;
  background-color: #F0F3FE;
  font-family: "Sukhumvit Set","Noto Sans Thai",Tahoma,sans-serif;

  @media screen and (min-width: 780px) {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 40px 16px;
  }
}

.lwnp-box {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #F0F3FE;

  @media screen and (min-width: 780px) {
    min-height: unset;
    max-width: 480px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(46,58,230,.12);
  }
}

.nf-header {
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
  padding: 6px 8px 12px;
  border-bottom: 1px solid #DCE4EF;
  background: #FFFFFF;
  flex: none;
}

.nf-header-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
}

.nf-back {
  border: 0;
  background: none;
  color: #2E3AE6;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  cursor: pointer;
  padding: 0;
  > svg {
    width: 20px;
    height: 20px;
  }
  &:focus-visible {
    outline: 2px solid #2E3AE6;
    outline-offset: 2px;
    border-radius: 4px;
  }
}

.nf-pane {
  --nf-blue: #2E3AE6;
  --nf-ink: #111111;
  --nf-muted: #6A6A6A;
  --nf-faint: #9A9A9A;
  --nf-line: #DCE4EF;
  --nf-tint: #F4F6FF;
  --nf-outline: #8E95EE;
  --nf-ui: "Sukhumvit Set","Noto Sans Thai",Tahoma,sans-serif;

  font-family: var(--nf-ui);
  font-size: 15px;
  padding: 20px 18px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nf-warn {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #FFF1E0;
  color: #E07A00;
  display: grid;
  place-items: center;
  font-size: 2rem;
  font-weight: 700;
  margin: 8px auto 0;
}

.nf-title {
  font-size: 1.45rem;
  line-height: 1.3;
  margin: 0;
  font-weight: 700;
  color: #000000;
}

.nf-phone {
  font-weight: 600;
  font-size: 1.05rem;
  background: #FFFFFF;
  border: 1px solid var(--nf-line);
  color: var(--nf-blue);
  border-radius: 14px;
  padding: 12px;
  text-align: center;
  letter-spacing: .02em;
}

.nf-hint {
  margin: 0;
  color: var(--nf-muted);
  font-size: .88rem;
  line-height: 1.55;
  text-align: center;
}

.nf-link {
  background: none;
  border: 0;
  padding: 0;
  color: var(--nf-blue);
  font: 500 .85rem var(--nf-ui);
  text-decoration: underline;
  cursor: pointer;
}

.nf-body {
  margin: 0;
  color: var(--nf-muted);
  font-size: .88rem;
  line-height: 1.55;
}

.nf-center { text-align: center; }

.nf-done-mark {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: linear-gradient(110deg, #2E3AE6 0%, #4E5BEE 55%, #6B77F6 100%);
  color: #FFFFFF;
  display: grid;
  place-items: center;
  font-size: 2rem;
  font-weight: 600;
  margin: 8px auto 0;
  box-shadow: 0 14px 28px -14px rgba(46, 58, 230, .6);
}

.nf-btn {
  display: block;
  width: 100%;
  border: 0;
  border-radius: 12px;
  padding: 14px;
  font: 600 1rem var(--nf-ui);
  cursor: pointer;
  background: #2E3AE6;
  color: #FFFFFF;
  &:disabled {
    opacity: .6;
    cursor: not-allowed;
  }
}

/* intro screen */
.nf-hero-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: linear-gradient(135deg, #2E3AE6 0%, #4E5BEE 60%, #6B77F6 100%);
  border-radius: 18px;
  padding: 18px 20px;
  color: #FFFFFF;
  > small { font-size: .78rem; opacity: .85; }
  > b { font-size: 1.1rem; font-weight: 700; }
  > span { font-size: .82rem; opacity: .9; line-height: 1.5; }
}

.nf-steps-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  > li {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-size: .93rem;
    color: var(--nf-ink);
    line-height: 1.45;
  }
}

.nf-step-n {
  flex: none;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--nf-blue);
  color: #FFFFFF;
  display: grid;
  place-items: center;
  font-size: .78rem;
  font-weight: 700;
}

.nf-prep {
  background: #FFFFFF;
  border: 1px dashed #B0BBF4;
  border-radius: 14px;
  padding: 14px 16px;
  font-size: .86rem;
  color: var(--nf-muted);
  line-height: 1.6;
  > b { color: var(--nf-ink); }
}

/* form screen */
.nf-pane-form {
  gap: 10px;
  padding-bottom: 40px;
  overflow-y: auto;
}

.nf-sec-title {
  font-size: .82rem;
  font-weight: 600;
  color: var(--nf-muted);
  text-transform: uppercase;
  letter-spacing: .04em;
  border-top: 1px solid var(--nf-line);
  padding-top: 12px;
  margin-top: 6px;
  &:first-child { border-top: none; margin-top: 0; padding-top: 0; }
}

.nf-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.nf-label {
  font-size: .88rem;
  font-weight: 500;
  color: var(--nf-ink);
  display: flex;
  align-items: center;
  gap: 4px;
}

.nf-req { color: #E03535; font-weight: 700; }

.nf-opt {
  font-size: .75rem;
  font-weight: 400;
  color: var(--nf-faint);
  background: #F2F4FF;
  border-radius: 6px;
  padding: 1px 6px;
  margin-left: 4px;
}

.nf-input, .nf-select {
  width: 100%;
  font: 400 1rem var(--nf-ui);
  color: var(--nf-ink);
  background: #FFFFFF;
  border: 1px solid #DFDFDF;
  border-radius: 12px;
  padding: 11px 14px;
  min-height: 48px;
  box-sizing: border-box;
  appearance: none;
  &:focus {
    outline: none;
    border-color: #2E3AE6;
    box-shadow: 0 0 0 3px rgba(46,58,230,.16);
  }
  &:disabled {
    background: #F9F9F9;
    border-color: #F2F2F2;
    color: #AFAFAF;
  }
}

.nf-select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236A6A6A' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 34px;
  cursor: pointer;
}

.nf-field-invalid {
  .nf-input, .nf-select { border-color: #E03535; background: #FFF4F4; }
}

.nf-err {
  font-size: .78rem;
  color: #E03535;
  margin: 0;
}

.nf-check {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: .88rem;
  color: var(--nf-ink);
  cursor: pointer;
  line-height: 1.45;
  > input[type=checkbox] { margin-top: 2px; flex: none; width: 16px; height: 16px; cursor: pointer; accent-color: #2E3AE6; }
}

.nf-sub-field {
  margin-left: 24px;
  background: #F9FBFF;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1px solid #E8EDFA;
}

.nf-row3 {
  display: grid;
  grid-template-columns: 1fr 1.6fr 1.2fr;
  gap: 8px;
}

.nf-phone-locked {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #F4F6FF;
  border: 1.5px solid #C4CCF5;
  border-radius: 12px;
  padding: 12px 14px;
  > b { font-size: 1.05rem; color: var(--nf-blue); }
}

.nf-verified {
  font-size: .78rem;
  background: #E6FFED;
  color: #1A7A3A;
  border-radius: 8px;
  padding: 3px 8px;
  white-space: nowrap;
}

.nf-help {
  font-size: .8rem;
  color: var(--nf-faint);
  line-height: 1.5;
}

.nf-form-err {
  display: block;
  font-size: .88rem;
  color: #E03535;
  background: #FFF4F4;
  border-radius: 10px;
  padding: 10px 14px;
  text-align: center;
}

.nf-pill {
  display: inline-block;
  font: 600 .78rem var(--nf-ui);
  border-radius: 100px;
  padding: 4px 12px;
  background: #FFF1E0;
  color: #B85C00;
  align-self: flex-start;
}

.nf-kv {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px 14px;
  font-size: .86rem;
  background: #FFFFFF;
  border: 1px solid var(--nf-line);
  border-radius: 16px;
  padding: 14px 16px;
  margin: 0;
  > dt { color: var(--nf-muted); white-space: nowrap; }
  > dd { margin: 0; color: var(--nf-ink); font-weight: 500; }
}
</style>
